export default "__VITE_ASSET__xR7AQA0T__"